/**
 * Individual Question View
 */
 define('Question.View',
 [ 
    'SCView',
    'Question.Collection', 
    'question.tpl'
 ],
 function (
    SCViewModule,
    QuestionCollection, 
    template
 ) {

   'use strict';

    var SCView = SCViewModule.SCView;

    function QuestionView (options) {
        SCView.call(this, options);
        this.model = options.model;

        this.template = template;

    }

    QuestionView.prototype = Object.create(SCView.prototype);
    QuestionView.prototype.constructor = QuestionView;

    QuestionView.prototype.getContext = function () {
        var self = this;
       
        //Expand First Answer
        var expandAnswer = false;

        if (self.model.get("allResults")) {
            var rowNo = self.model.get("allResults").values.formulanumeric;
            if (rowNo == 1) {
                expandAnswer = true;
            }
        }
                
        //Get First Name of Employee
        var answeredBy = '';

        if (self.model.get("answeredBy")) {
            answeredBy = self.model.get("allResults").values['CUSTRECORD_TT_ANSWERER_EMPLOYEE.firstname'];
        }

        //Convert Date Created
        var dateCreated = '';

        if (self.model.get("dateCreated")) {

            var getDateCreated = self.model.get("dateCreated");
            var newDate = new Date(getDateCreated).toDateString()
            var dateSplit = newDate.split(' ');

            dateCreated = dateSplit[1] + ' ' + dateSplit[2] + ', ' + dateSplit[3];
        
        }

        //Convert Date Answered
        var dateAnswered = '';

        if (self.model.get("dateAnswered")) {

            var getDateAnswered = self.model.get("dateAnswered");
            var newDate = new Date(getDateAnswered).toDateString()
            var dateSplit = newDate.split(' ');
            
            dateAnswered = dateSplit[1] + ' ' + dateSplit[2] + ', ' + dateSplit[3];

        }

        //@class Question.View.Context
        return {
            //@property {String} questionId
            questionId : self.model.get("internalid"),
            //@property {String} question
            question : self.model.get("question"),
            //@property {String} answer
            answer : self.model.get("answer"),
            //@property {String} displayName
            displayName : self.model.get("displayName"),
            //@property {String} dateCreated
            dateCreated : dateCreated ? dateCreated : self.model.get("dateCreated"),
            //@property {String} answeredBy
            answeredBy : answeredBy ? answeredBy : self.model.get("answeredBy"),
            //@property {String} dateAnswered
            dateAnswered : dateAnswered ? dateAnswered : self.model.get("dateAnswered"),
            //@property {String} expandAnswer
            expandAnswer : expandAnswer
        };
    }

    return QuestionView
 })
